(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["repolished-collection-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!Shopify.designMode) return;

  var syncTimer = null;

  function handleize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function parseRegistry(raw) {
    var map = {};
    if (!raw) return map;
    String(raw).split('@@@').forEach(function (record) {
      record = record.trim();
      if (!record) return;
      var parts = record.split('|||');
      if (!parts[0]) return;
      map[parts[0].trim()] = {
        title: (parts[1] || '').trim(),
        description: (parts[2] || '').trim()
      };
    });
    return map;
  }

  function serializeRegistry(map) {
    return Object.keys(map).map(function (key) {
      var entry = map[key] || {};
      return key + '|||' + (entry.title || '') + '|||' + (entry.description || '');
    }).join('@@@');
  }

  function getEditorDoc() {
    try {
      return window.parent && window.parent.document ? window.parent.document : document;
    } catch (error) {
      return document;
    }
  }

  function readInput(doc, name) {
    var input = doc.querySelector('[name="' + name + '"]');
    return input ? String(input.value || '').trim() : '';
  }

  function collectRegistryFromSidebar(doc) {
    var map = {};
    var titleInputs = doc.querySelectorAll('[name*="[settings][meta_title]"]');

    titleInputs.forEach(function (titleInput) {
      var name = titleInput.getAttribute('name') || '';
      if (name.indexOf('[blocks]') === -1) return;

      var blockMatch = name.match(/\[blocks\]\[([^\]]+)\]/);
      if (!blockMatch) return;

      var base = name.split('[settings]')[0];
      if (doc.querySelector('[name="' + base + '[settings][collection]"]')) return;

      var title = String(titleInput.value || '').trim();
      var description = readInput(doc, base + '[settings][meta_description]');
      var tag = readInput(doc, base + '[settings][match_tag]');
      var collection = handleize(readInput(doc, base + '[settings][match_collection]'));

      if (!title && !description) return;

      var key = '';
      if (tag) {
        if (!collection) {
          var context = document.querySelector('[data-rr-page-seo-key]');
          var pageKey = context ? context.getAttribute('data-rr-page-seo-key') || '' : '';
          collection = pageKey.indexOf('/') > -1 ? pageKey.split('/')[0] : pageKey;
        }
        if (!collection) return;
        key = collection + '/' + handleize(tag);
      } else {
        key = collection;
        if (!key) {
          var contextNode = document.querySelector('[data-rr-page-seo-key]');
          var fallbackKey = contextNode ? contextNode.getAttribute('data-rr-page-seo-key') || '' : '';
          key = fallbackKey.indexOf('/') > -1 ? fallbackKey.split('/')[0] : fallbackKey;
        }
      }

      if (!key) return;
      map[key] = { title: title, description: description };
    });

    return map;
  }

  function collectRegistryFromPreview() {
    var builtNode = document.getElementById('rr-seo-registry-data');
    if (!builtNode) return {};
    var builtRaw = '';
    try {
      builtRaw = JSON.parse(builtNode.textContent || '""');
    } catch (error) {
      builtRaw = builtNode.textContent || '';
    }
    return parseRegistry(builtRaw);
  }

  function setNativeInputValue(input, value) {
    if (!input) return;
    var prototype = Object.getPrototypeOf(input);
    var descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor && descriptor.set) {
      descriptor.set.call(input, value);
    } else {
      input.value = value;
    }
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fillSettingInput(doc, fieldName, value) {
    if (!doc || value == null) return false;
    var updated = false;
    var selectors = [
      '[name="settings[' + fieldName + ']"]',
      '[name$="[' + fieldName + ']"]',
      'input[id*="' + fieldName + '"]',
      'input[name*="' + fieldName + '"]',
      'textarea[id*="' + fieldName + '"]',
      'textarea[name*="' + fieldName + '"]',
      '[data-setting-id="' + fieldName + '"]'
    ];

    selectors.forEach(function (selector) {
      doc.querySelectorAll(selector).forEach(function (input) {
        setNativeInputValue(input, value);
        updated = true;
      });
    });

    return updated;
  }

  function getThemeId() {
    var themeNode = document.getElementById('rr-seo-theme-id');
    if (themeNode) {
      try {
        return JSON.parse(themeNode.textContent || '""');
      } catch (error) {
        return themeNode.textContent;
      }
    }

    try {
      var match = window.parent.location.href.match(/themes\/(\d+)/);
      if (match) return match[1];
    } catch (error) {
      /* ignore */
    }

    return null;
  }

  function persistRegistryAsset(registryValue) {
    var doc = getEditorDoc();
    var themeId = getThemeId();
    if (!themeId || !registryValue) return Promise.resolve(false);

    var csrf =
      doc.querySelector('meta[name="csrf-token"]')?.content ||
      doc.querySelector('meta[name="csrf-token-value"]')?.content ||
      doc.querySelector('meta[name="csrf-param"]')?.content;

    var headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    };
    if (csrf) headers['X-CSRF-Token'] = csrf;

    return fetch('/admin/themes/' + themeId + '/assets.json', {
      method: 'PUT',
      credentials: 'include',
      headers: headers,
      body: JSON.stringify({
        asset: {
          key: 'snippets/rr-seo-registry-store.liquid',
          value: registryValue + '\n'
        }
      })
    })
      .then(function (response) {
        return response.ok;
      })
      .catch(function () {
        return false;
      });
  }

  function syncRegistry() {
    var doc = getEditorDoc();
    var existingNode = document.getElementById('rr-seo-registry-existing');
    var existingRaw = '';

    if (existingNode) {
      try {
        existingRaw = JSON.parse(existingNode.textContent || '""');
      } catch (error) {
        existingRaw = existingNode.textContent || '';
      }
    }

    var sidebar = collectRegistryFromSidebar(doc);
    var preview = collectRegistryFromPreview();
    var existing = parseRegistry(existingRaw);
    var merged = {};

    Object.keys(existing).forEach(function (key) {
      merged[key] = existing[key];
    });
    Object.keys(preview).forEach(function (key) {
      merged[key] = preview[key];
    });
    Object.keys(sidebar).forEach(function (key) {
      merged[key] = sidebar[key];
    });

    var mergedRaw = serializeRegistry(merged);
    if (!mergedRaw) return;

    fillSettingInput(doc, 'seo_registry', mergedRaw);
    fillSettingInput(doc, 'rr_collection_seo_registry', mergedRaw);
    persistRegistryAsset(mergedRaw);
  }

  function scheduleSync() {
    if (syncTimer) window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncRegistry, 200);
  }

  function syncPagePath() {
    var doc = getEditorDoc();
    var context = document.querySelector('[data-rr-page-seo-key]');
    if (context) {
      fillSettingInput(doc, 'match_tag', context.getAttribute('data-rr-page-seo-tag') || '');
    }
    scheduleSync();
  }

  document.addEventListener('shopify:section:load', syncPagePath);
  document.addEventListener('shopify:section:select', syncPagePath);
  document.addEventListener('shopify:section:unload', syncRegistry);
  document.addEventListener('shopify:block:select', syncPagePath);
  document.addEventListener('shopify:block:deselect', scheduleSync);

  try {
    var parentDoc = getEditorDoc();
    parentDoc.addEventListener('input', scheduleSync, true);
    parentDoc.addEventListener('change', scheduleSync, true);
    parentDoc.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (target.closest('[data-testid="save"], [aria-label*="Save"], button[type="submit"]')) {
        syncRegistry();
      }
    }, true);
    parentDoc.addEventListener('keydown', function (event) {
      if ((event.ctrlKey || event.metaKey) && String(event.key || '').toLowerCase() === 's') {
        syncRegistry();
      }
    }, true);
  } catch (error) {
    /* Theme editor may block parent-frame access */
  }

  window.setInterval(function () {
    scheduleSync();
  }, 2500);

  syncPagePath();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["repolished-product-seo"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!Shopify.designMode) return;

  function getPageKey() {
    var el = document.querySelector('[data-rr-page-seo-key]');
    return el ? el.getAttribute('data-rr-page-seo-key') : '';
  }

  function fillPagePathInput(key) {
    if (!key) return;

    try {
      var doc = window.parent && window.parent.document ? window.parent.document : document;
      var inputs = doc.querySelectorAll('input[id*="page_path"], input[name*="page_path"]');

      inputs.forEach(function (input) {
        if (input && !String(input.value || '').trim()) {
          input.value = key;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    } catch (error) {
      /* Theme editor may block parent-frame access */
    }
  }

  function syncPagePath() {
    fillPagePathInput(getPageKey());
  }

  document.addEventListener('shopify:section:load', syncPagePath);
  document.addEventListener('shopify:section:select', syncPagePath);
  document.addEventListener('shopify:block:select', syncPagePath);
  syncPagePath();
})();

  } catch(e) { console.error(e); }
})();
})();
